// MoreButton.tsx
import { useState } from "react";
import "./MoreButton.css";
import { ArrowSVG } from "src/images/arrow";

interface MoreButtonProps {
  buttonText?: string;
  onClick: () => void; // Define the type of the callback function
}

const MoreButton: React.FC<MoreButtonProps> = ({buttonText, onClick }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <button
      className="more-button"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={onClick} // Attach the onClick prop to the button
    >
      {buttonText ?? "more"} <ArrowSVG fill={hovered ? "#CCF2FF" : "#3287FF"} />
    </button>
  );
};

export default MoreButton;
